import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete_row",
  "use": "delete_row-usage",
  "viewBox": "0 0 25 14",
  "content": "<symbol viewBox=\"0 0 25 14\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"delete_row\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5.866A1 1 0 013.866.5l19.053 11a1 1 0 01-1 1.732l-19.053-11A1 1 0 012.5.866zM.866 3.134v-.015L3.15 4.437a.997.997 0 00-.283.697v4a1 1 0 001 1h9.15l3.464 2H1.866a1 1 0 01-1-1v-8zm10.294-1l3.464 2h7.242a1 1 0 011 1v3.758l2 1.155V3.134a1 1 0 00-1-1H11.16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol